import {Component, OnDestroy, OnInit} from '@angular/core';
import {SectionBase} from '../../../components/section/section-base';
import {OfferRecommendationsService} from '../../../../core/services/impl/offer-recommendations.service';
import {OfferRecommendation} from '../../../../core/services/impl/offer-recommendations-api.service';

@Component({
  selector: 'app-offer-recommendations-section',
  templateUrl: './offer-recommendations-section.component.html',
  styleUrls: []
})
export class OfferRecommendationsSectionComponent extends SectionBase implements OnInit, OnDestroy {

  public get valid(): boolean {
    return true;
  }

  get completeRecommendations(): boolean {
    const validRecommendations = this.offerRecommendationsService.activeRecommendations
        .filter(recommendation => this.isRecommendationValid(recommendation));
    return validRecommendations ? validRecommendations.length === 3 : false;
  }

  constructor(public offerRecommendationsService: OfferRecommendationsService) {
    super();
  }

  ngOnInit() {
    this.offerRecommendationsService.init();
  }

  ngOnDestroy() {
    this.offerRecommendationsService.clearUpdateInterval();
    this.offerRecommendationsService.clearWebsocketOpenedTimeout();
  }

  createConfig(): void {
  }

  initBean(): void {
  }

  initControlsChanges(): void {
  }

  isRecommendationValid(recommendation: OfferRecommendation): boolean {
    return !!recommendation.offerId && !!this.offerRecommendationsService.getConfig(recommendation.recommendationType) && !!recommendation.offer;
  }

  public submitSection(): void {
    // section hasn't form to submit
  }

}
